<template>
  <div>

    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <!-- Breadcrumb -->
      <app-breadcrumb>
        <template #contentright>
          <b-button
            v-if="$route.params.id !== undefined"
            variant="success"
            :to="{ name: 'studio-add' }"
          >
            <span class="text-nowrap">
              <feather-icon icon="PlusCircleIcon" /> {{ $t('Add New') }}
            </span>
          </b-button>
          <span v-else />
        </template>
      </app-breadcrumb>
      <b-row>
        <b-col md="12">
          <b-card aria-hidden="true">
            <!-- Alert: No item found -->
            <b-alert
              variant="danger"
              :show="errorMessage !== ''"
            >
              <h4 class="alert-heading">
                {{ errorMessage }}
              </h4>

            </b-alert>

            <!-- BODY -->
            <validation-observer
              #default="{ handleSubmit }"
              ref="refFormObserver"
            >
              <!-- Form -->
              <b-form
                class=""
                @submit.prevent="handleSubmit(onSubmit)"
                @reset.prevent="resetForm"
              >
                <b-row>
                  <!-- Bên trái -->
                  <b-col>
                    <b-col
                      md="12"
                      class="row"
                    >
                      <b-col md="8">
                        <!-- Name -->
                        <validation-provider
                          #default="validationContext"
                          :name="$t('Tên công việc')"
                          rules="required"
                        >
                          <b-form-group>
                            <template #label>
                              <label class="d-block font-weight-bolder">Tên công việc <span class="text-danger">*</span></label>
                            </template>
                            <b-form-input
                              id="name"
                              v-model="itemData.name"
                              :state="getValidationState(validationContext)"
                              trim
                            />

                            <b-form-invalid-feedback>
                              {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </validation-provider>
                      </b-col>
                      <b-col md="4">

                        <validation-provider
                          #default="validationContext"
                          :name="$t('Danh mục công việc')"
                          rules="required"
                        >
                          <b-form-group label-for="category_work_id">
                            <template #label>
                              <label class="d-block font-weight-bolder">Danh mục công việc <span class="text-danger">*</span></label>
                            </template>
                            <v-select
                              v-model="itemData.category_work_id"
                              :options="dataCategoryWork"
                              :reduce="val => val.id"
                              label="name"
                              placeholder="--Chọn--"
                            />
                            <b-form-invalid-feedback :state="getValidationState(validationContext)">
                              {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </validation-provider>
                      </b-col>
                    </b-col>
                    <b-col
                      md="12"
                      class="row"
                    >
                      <b-col md="8">
                        <!-- Mô tả -->
                        <b-form-group>
                          <template #label>
                            <label class="d-block font-weight-bolder">Nội dung </label>
                          </template>
                          <b-form-textarea
                            id="description"
                            v-model="itemData.content"
                            rows="4"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col md="4">
                        <b-form-group id="group_finished_volume">

                          <template #label>
                            <label class="d-block font-weight-bolder">Khối lượng công việc</label>
                          </template>
                          <b-form-input
                            id="finished_volume"
                            v-model="itemData.finished_volume"
                            type="range"
                            min="0"
                            max="100"
                          />
                          <span>{{ itemData.finished_volume }}%</span>

                        </b-form-group>
                        <validation-provider
                          #default="validationContext"
                          :name="$t('Mức độ ưu tiên')"
                          rules="required"
                        >
                          <b-form-group label-for="manager_id">
                            <template #label>
                              <label class="d-block font-weight-bolder">Mức độ ưu tiên <span class="text-danger">*</span></label>
                            </template>
                            <v-select
                              v-model="itemData.priority"
                              :options="priorityOptions"
                              :reduce="val => val.id"
                              label="name"
                              placeholder="--Chọn--"
                            />
                            <b-form-invalid-feedback :state="getValidationState(validationContext)">
                              {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </validation-provider>
                        <validation-provider
                          #default="validationContext"
                          :name="$t('Trạng thái')"
                          rules="required"
                        >
                          <b-form-group label-for="manager_id">
                            <template #label>
                              <label class="d-block font-weight-bolder">Trạng thái <span class="text-danger">*</span></label>
                            </template>
                            <v-select
                              v-model="itemData.status"
                              :options="statusOptions"
                              :reduce="val => val.id"
                              label="name"
                              placeholder="--Chọn--"
                            />
                            <b-form-invalid-feedback :state="getValidationState(validationContext)">
                              {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </validation-provider>
                      </b-col>
                    </b-col>
                    <b-col
                      md="12"
                      class="row"
                    >
                      <b-col md="8">
                        <!-- Người thực hiện -->
                        <validation-provider
                          #default="validationContext"
                          :name="$t('Người thực hiện')"
                          rules="required"
                        >
                          <b-form-group label-for="manager_id">
                            <template #label>
                              <label class="d-block font-weight-bolder">Người thực hiện <span class="text-danger">*</span></label>
                            </template>
                            <v-select
                              v-model="itemData.main_user_id"
                              :options="dataUser"
                              :reduce="val => val.id"
                              label="full_name"
                              placeholder="--Chọn--"
                            />
                            <b-form-invalid-feedback :state="getValidationState(validationContext)">
                              {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </validation-provider>
                      </b-col>
                      <b-col md="4">
                        <validation-provider
                          #default="validationContext"
                          vid="begin_date"
                          name="Thời gian bắt đầu"
                          rules="required"
                        >
                          <b-form-group
                            label="Thời gian bắt đầu"
                            label-for="begin_date"
                          >
                            <template #label>
                              <label class="d-block font-weight-bolder pb-0">Thời gian bắt đầu<span class="text-danger">*</span></label>
                            </template>
                            <flat-pickr
                              v-model="itemData.begin_date"
                              class="form-control"
                              :config="configDate"
                              placeholder="dd-mm-yyyy hh:i"
                              theme="dark"
                              :state="getValidationState(validationContext)"
                            />
                            <b-form-invalid-feedback :state="getValidationState(validationContext)">
                              {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </validation-provider>

                      </b-col>
                    </b-col>
                    <b-col
                      md="12"
                      class="row"
                    >
                      <b-col md="8">
                        <!-- Người phối hợp thực hiện -->
                        <b-form-group label-for="manager_id">
                          <template #label>
                            <label class="d-block font-weight-bolder">Người phối hợp thực hiện </label>
                          </template>
                          <v-select
                            v-model="itemData.data_list_user_collaborators"
                            :options="dataUser"
                            :reduce="val => val.id"
                            label="full_name"
                            placeholder="--Chọn--"
                            :multiple="true"
                          />

                        </b-form-group>
                      </b-col>
                      <b-col md="4">

                        <validation-provider
                          #default="validationContext"
                          vid="end_date"
                          name="Thời gian kết thúc"
                          rules="required"
                        >
                          <b-form-group
                            label="Thời gian kết thúc"
                            label-for="end_date"
                          >
                            <template #label>
                              <label class="d-block font-weight-bolder pb-0">Thời gian kết thúc<span class="text-danger">*</span></label>
                            </template>
                            <flat-pickr
                              v-model="itemData.end_date"
                              class="form-control"
                              :config="configDate"
                              placeholder="dd-mm-yyyy hh:i"
                              theme="dark"
                              :state="getValidationState(validationContext)"
                            />
                            <b-form-invalid-feedback :state="getValidationState(validationContext)">
                              {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </validation-provider>
                      </b-col>
                    </b-col>

                    <b-col
                      md="12"
                      class="row"
                    >
                      <b-col md="8" />
                      <!-- File -->
                      <b-col cols="12">
                        <b-form-group>
                          <div class="attachedFiles">
                            <div class="fileupload">
                              <original-file
                                :attached-files="frmFiles"
                                @update-attached-files="onUpdateAttachedFiles"
                              />
                            </div>
                          </div>
                        </b-form-group>
                      </b-col>
                    </b-col>
                  </b-col>

                </b-row>

                <!-- Form Actions -->
                <div class="d-flex mt-2">
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    class="mr-2"
                    type="submit"
                  >
                    {{ $t('Save') }}
                  </b-button>
                </div>

              </b-form>
            </validation-observer>
          </b-card>

        </b-col>
      </b-row>
    </b-overlay>
  </div>
</template>

<script>
import {
  BRow, BCol, BCard, BAlert, BOverlay, BForm, BFormGroup, BButton, BFormInput, BFormInvalidFeedback,
  BFormTextarea,
} from 'bootstrap-vue'
import {
  ref, reactive, toRefs,
} from '@vue/composition-api'
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import Ripple from 'vue-ripple-directive'
import flatPickr from 'vue-flatpickr-component'
import { Vietnamese } from 'flatpickr/dist/l10n/vn'
import vSelect from 'vue-select'
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'
import formValidation from '@core/comp-functions/forms/form-validation'
import {
  required, alphaNum, alphaNumDot, max, integer, positive,
} from '@validations';
import { useRouter, showToast } from '@core/utils/utils';
import store from '@/store'
import { getToken } from '@/auth/utils'
import {
  apiUpload, apiDownload,
} from '@/libs/initTinymce'

import OriginalFile from './OriginalFile.vue';

export default {
  components: {
    AppBreadcrumb,
    BRow,
    BCol,
    BCard,
    BAlert,
    BOverlay,
    BForm,
    BFormGroup,
    BButton,
    BFormInput,
    BFormInvalidFeedback,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    flatPickr,
    BFormTextarea,
    OriginalFile,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      required,
      integer,
      alphaNum,
      alphaNumDot,
      max,
      positive,
      devices: [],
      // items: [],
      forceUpdate: 0,
    }
  },
  watch: {
  },
  methods: {
    onDeleteAttach(file) {
      if (this.attachedFiles.length > 0) {
        const attachedFiles = this.attachedFiles.filter((item) => item.id !== file.id)
        this.$refs.uploadAttach.remove(file);
        this.frmFiles = attachedFiles;

        // console.log(this.attachedFiles)
      }
    },
    onUpdateAttachedFiles(file) {
      this.frmFiles = file
    },
  },
  setup(props, context) {
    const { route, router } = useRouter();
    const id = ref(route.value.params.id !== undefined ? route.value.params.id : 0);
    const layout = ref(route.value.name !== 'devices-edit' ? 'add' : 'edit');
    const loading = ref(!!id.value)
    const errorMessage = ref('')
    const dataCategoryWork = ref([])
    const dataUser = ref([])
    const accessToken = getToken()
    const attachedFiles = ref([])
    const frmFiles = ref([])
    const custom_header = ref({
      Authorization: `Bearer ${accessToken}`,
    });
    const state = reactive({
      api_upload: apiUpload,
      api_download: apiDownload,
    })
    const statusOptions = [
      { name: 'Đang thực hiện', id: 10 },
      { name: 'Duyệt', id: 20 },
      { name: 'Tạm dừng', id: 30 },
      { name: 'Từ chối', id: 40 },
    ];
    const priorityOptions = [
      { name: 'Cao', id: 10 },
      { name: 'Trung bình', id: 20 },
      { name: 'Bình thường', id: 30 },
      { name: 'Thấp', id: 40 },
    ];
    const defaultItemData = {
      name: '',
      content: '',
      status: 10,
      main_user_id: null,
      data_list_user_collaborators: [],
      note: '',
      finished_volume: 0,
      category_work_id: null,
      priority: 10,
    }
    const itemData = ref(JSON.parse(JSON.stringify(defaultItemData)))

    const resetItemData = () => {
      itemData.value = JSON.parse(JSON.stringify(defaultItemData))
    }
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetItemData)

    const onSubmit = () => {
      errorMessage.value = '';
      loading.value = true;
      // itemData.value.attachedFiles = attachedFiles.value;
      itemData.value.attachedFiles = frmFiles.value;
      store.dispatch('listWork/create', itemData.value)
        .then((response) => {
          if (response.status === 200) {
            if (response.data.code === 200) {
              showToast(response.data.message, { variant: 'success' });
              resetForm()
              router.push({ name: 'work-list' })
            } else {
              showToast(response.data.message)
              errorMessage.value = response.data.message;
            }
          } else {
            loading.value = false;
          }
        })
    }
    const fetchCategoryWork = () => {
      store.dispatch('listWork/fetchAllCategoryWork', {
        isPaginate: 0,
      })
        .then(response => {
          if (response.data.code === 200) {
            dataCategoryWork.value = response.data.data;
          }
        })
    }
    fetchCategoryWork();

    const fetchManager = () => {
      store.dispatch('users/fetchUsers', {
        isPaginate: '0',
      })
        .then(response => {
          if (response.data.code === 200) {
            dataUser.value = response.data.data;
          }
        })
    }
    fetchManager();

    const today = new Date();
    const hour = today.getHours();
    const minutes = today.getMinutes();
    const configDate = ref({
      dateFormat: 'd-m-Y H:i',
      enableTime: true,
      locale: Vietnamese, // locale for this instance only
      defaultHour: hour,
      defaultMinute: minutes,
      time_24hr: true,
      theme: 'dark',
    });

    return {
      ...toRefs(state),
      id,
      layout,
      errorMessage,
      loading,
      itemData,
      // devices,
      refFormObserver,
      getValidationState,
      resetForm,
      resetItemData,
      onSubmit,
      // fetchData,
      dataUser,
      configDate,
      // convertCurrency,
      statusOptions,
      dataCategoryWork,
      priorityOptions,
      attachedFiles,
      frmFiles,
      custom_header,
    }
  },

}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

#group_finished_volume>div {
  display: flex;
}

#finished_volume {
  margin-right: 15px;
}
</style>
